
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2nFd6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ff829801f4d369f4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $ff829801f4d369f4$export$2e2bcd8739ae039 = {
    "'Goals.CreateGoal.footer.create-label": 'Opret',
    'Goals.CreateGoal.EditMetric.header': "Rediger m\xe5ling",
    'Goals.CreateGoal.create.error': "Kunne ikke oprette m\xe5l",
    'Goals.CreateGoal.create.network.error': 'Forbindelsen mislykkedes',
    'Goals.CreateGoal.create.permission.error': "Du har ikke den n\xf8dvendige tilladelse til at oprette et m\xe5l.",
    'Goals.CreateGoal.error.description': "Der gik noget galt. Kontroll\xe9r din internetforbindelse, og pr\xf8v igen.",
    'Goals.CreateGoal.error.header': "Kunne ikke oprette m\xe5l",
    'Goals.CreateGoal.footer.cancel-label': 'Annuller',
    'Goals.CreateGoal.form.icon.back-button-label': 'Tilbage',
    'Goals.CreateGoal.form.name.error': "Du skal angive et m\xe5lnavn",
    'Goals.CreateGoal.form.name.label': 'Navn',
    'Goals.CreateGoal.form.owner.error': 'Ejer skal udfyldes.',
    'Goals.CreateGoal.header': "Opret m\xe5l",
    'Goals.CreateGoal.parent-goal-label': "Overordnet m\xe5l",
    'Goals.CreateGoal.parent-goal.error': "Overordnet m\xe5l skal udfyldes.",
    'Goals.CreateGoal.required-fields-are-marked': 'Obligatoriske felter er markeret med stjerne <asterisk></asterisk>',
    'Goals.CreateGoal.site-label': 'Website',
    'Goals.CreateGoal.type-label': 'Type',
    'Goals.CreateGoal.type-label-placeholder': 'Hvad skal vi kalde det?',
    'Goals.CreateMetric.add-metric-button': "Tilf\xf8j m\xe5ling",
    'Goals.CreateMetric.metric-select.create-new': "Opret ny m\xe5ling",
    'Goals.CreateMetric.metric-select.use-existing': "Brug eksisterende m\xe5ling",
    'Goals.CreateMetric.metric-start-value.label': "Startv\xe6rdi",
    'Goals.CreateMetric.metric-target-value.label': "M\xe5lv\xe6rdi",
    'Goals.CreateMetric.metric-unit-select.label': 'Enhed',
    'Goals.GoalCreationModal.label.date-selection-placeholder': "V\xe6lg en dato",
    'Goals.GoalCreationModal.label.date-selection-title': "M\xe5ldato",
    'Goals.GoalCreationModal.label.owner-picker-placeholder': 'Indtast person',
    'Goals.GoalCreationModal.label.owner-selection-title': 'Ejer',
    'townsquare.api.goal-type-description.goal': "Generelle m\xe5l",
    'townsquare.api.goal-type-description.key-result': "Den kvantitative m\xe5de at m\xe5le et m\xe5l p\xe5 (OKR-ramme).",
    'townsquare.api.goal-type-description.objective': "Det \xf8nskede resultat (OKR-ramme)."
};

});


//# sourceMappingURL=da.3b102b96.js.map
